import $ from 'jquery';
import gsap from 'gsap';
//import 'select2/dist/css/select2.min.css';
import 'select2';
import common from '../utils/common';
import search from '../utils/search';
import drop from '../utils/drop';

const transfers = {
	active: false,

	init() {


		this.active = true;

		this.initDestinationsSearch();

		// if (common.$windowW < 768) {
		// 	$('.__owl_populars').owlCarousel({
		// 		loop: true,
		// 		margin: 5,
		// 		stagePadding: 5,
		// 		mouseDrag: true,
		// 		touchDrag: true,
		// 		dots: false,
		// 		nav: false,
		// 		responsive: {
		// 			0: { items: 1.5 },
		// 			500: { items: 1.8 },
		// 			610: { items: 2.5 }
		// 		}
		// 	});
		// }

		if ($(".__transfers_results").length) {
			gsap.to("html,body", {
				scrollTo: $(".__transfers_results").position().top - 70,
				duration: 1,
				ease: "expo.out",
				delay: 0.6
			});
		}

		if ($("input[name=departure_id]").val()) {
			this.getDestinations(
				$("input[name=departure_id]").val(),
				$("input[name=departure_type]").val(),
				true
			);
		}

		//return false;

		$.getJSON(`${_SITE_URL}JSON/search_results_transfers.json?v=${search.rand}`, (data) => {
			$('.js-transfers').select2({
				data: data,
				placeholder: "Pick up location",
				allowClear: true,
				templateResult: this.formatRepo
			});
		});


		$('.js-transfers').on('select2:open', () => {
			this.cleanDestinations();
			// setTimeout(() => {
			// 	$(".select2-results__options").mCustomScrollbar({theme: "purple"});
			// }, 400);
		});

		$('.js-transfers').on('select2:closing', () => {
			//$(".select2-results__options").mCustomScrollbar('destroy');
		});

		$('.js-transfers').on('select2:select', (e) => {
			const data = e.params.data;
			this.getDestinations(data.id, data.type, false);
			$("input[name=departure_id]").val(data.id);
			$("input[name=departure_type]").val(data.type);
		});

		$('.js-transfers').on('select2:clearing', () => {
			this.cleanDestinations();
		});

		$(document).on('click', '._menu_dropdown[data-drop=trans_arrival] li:not(._disabled)', function () {
			const $arrival = $(this);
			const label = $arrival.data('label');

			$('input[name=arrival_id]').val($arrival.data('id'));
			$('input[name=arrival_type]').val($arrival.data('type'));
			$('input[name=_arrival_input]').val(label);
			$('._menu_dropdown[data-drop=trans_arrival]').removeClass('_show');
		});

		$('form[name=_form_transfers]').on('submit', (event) => {
			if (!this.check()) {
				event.preventDefault();
				$('._search_warning').stop(true, true).fadeIn(180).delay(2500).fadeOut(250);
			}
		});
	},

	// Filtre en direct la grille des destinations transferts (cf.
	// TRANSFERS/transfers_destinations.php et retours utilisateur : trop de
	// villes affichees d'un coup, il faut pouvoir taper un nom de ville et
	// la retrouver immediatement). Meme principe que le champ de recherche
	// FAQ (cf. pages/faq.js), sur une liste plate plutot que des categories.
	initDestinationsSearch() {
		const $search = $(".__transfers_dest_search");

		if (!$search.length) {
			return;
		}

		const normalize = (value) => value
			.toString()
			.normalize("NFD")
			.replace(/[\u0300-\u036f]/g, "")
			.toLowerCase();

		const $items = $("#transfers-dest-results > li");

		$search.on("input", (event) => {
			const query = normalize($(event.currentTarget).val().trim());
			let visibleCount = 0;

			$items.each((index, element) => {
				const $item = $(element);
				const matches = !query || ($item.data("search") || "").toString().indexOf(query) !== -1;

				$item.toggle(matches);
				if (matches) {
					visibleCount++;
				}
			});

			$(".__transfers_destinations .__faq_no_result").toggleClass("_show", visibleCount === 0);
		});
	},

	formatRepo(repo) {
		return $(`<div class='_line_${repo.type}'>${repo.text}</div>`);
	},

	cleanDestinations() {
		$("._menu_drop[data-drop=trans_arrival] > input").val("");
		$("input[name=arrival_id], input[name=arrival_type]").val("");
		$("._menu_dropdown[data-drop=trans_arrival] > .__bl_line").html("<span>Select a departure first</span>");
		drop.cleanResult();
		$("._menu_dropdown").removeClass("_show");
		//$("._menu_dropdown[data-drop=trans_arrival]").mCustomScrollbar('destroy');
	},

	getDestinations(id, type, force) {
		$.ajax({
			url: `${_SITE_URL}get-transfers-arrival`,
			type: 'post',
			data: {departure: id, type},
			success(response) {
				const obj = typeof response === 'string' ? $.parseJSON(response) : response;
				const validArrivals = [];

				obj.list.forEach(arrival => {
					if (!arrival.disable) {
						validArrivals.push(arrival);
					}

					Object.values(arrival).forEach(child => {
						if (child && typeof child === 'object' && child.type !== undefined) {
							validArrivals.push(child);
						}
					});
				});

				if (validArrivals.length === 1) {
					$("input[name=arrival_id]").val(validArrivals[0].id);
					$("input[name=arrival_type]").val(validArrivals[0].type);
					$("input[name=_arrival_input]").val(validArrivals[0].name);
				} else {
					let render = '<ul class="__ul_select">';
					obj.list.forEach(val => {
						if (val.id != null) {
							if (val.disable) {
								render += `<li class="_disabled _line_${val.type}"><div class="_title"><span>${val.name}</span></div></li>`;
							} else {
								render += `<li class="_line_${val.type}" data-type="${val.type}" data-id="${val.id}" data-label="${val.name}"><div class="_title"><span>${val.name}</span></div></li>`;
							}
							$.each(val, (j, locs) => {
								if (locs.type !== undefined) {
									render += `<li class="_line_${locs.type}" data-type="${locs.type}" data-id="${locs.id}" data-label="${locs.name}"><small>${locs.name}</small></li>`;
								}
							});
						}
					});
					render += '</ul>';

					//console.log(render);

					if (!force) {
						$("._menu_drop[data-drop=trans_arrival] > input").val("");
					}
					$("._menu_dropdown[data-drop=trans_arrival] > .__bl_line").html(render);
					// $("._menu_dropdown[data-drop=trans_arrival]").mCustomScrollbar({
					// 	theme: "purple",
					// 	mouseWheel: {scrollAmount: 250}
					// });
				}
			}
		});

	},

	check() {
		return $("input[name=departure_id]").val() !== "" && $("input[name=arrival_id]").val() !== "";
	},

	product() {
		if ($("input[name=product_roundtrip_price]").length) {
			product.roundTripPrice = $("input[name=product_roundtrip_price]").val();
			this.check_choice();
		}

		if (product.type === "TRANSFER" && $("input[name=time_transfer_01]").length) {
			_default_hour = "";
		}
		if ($("input[name=basket_extras]").length) {
			this.prepare_extras();
		}

		$("._time_prefer").flatpickr({
			enableTime: true,
			noCalendar: true,
			defaultDate: "09:00",
			dateFormat: "H:i",
			hourIncrement: 1,
			minuteIncrement: 15,
			time_24hr: false,
			onOpen(selectedDates, dateStr, instance) {
				if (mobile.state) {
					$("html,body").css("overflow", "hidden");
					$(".__modal_calendar_mobile_hours").addClass("_show");
					$(".flatpickr-calendar.hasTime").hide();
					$(".flatpickr-calendar.hasTime.open").addClass("inline").removeAttr("style").detach().appendTo(".__modal_calendar_mobile_hours > ._contain");
				}
			}
		});
		$("input.flatpickr-hour, input.flatpickr-minute").attr("readonly", true);

		if ($("input[name=product_roundtrip]").length) {
			product.roundTrip = $("input[name=product_roundtrip]").val();
			product.roundTripSave = $("input[name=product_roundtrip]").val();
		}

		$(document).on("change", "input[name=transfer_choice]", function () {
			if ($(this).val() === "RT") {
				$("._transfer_return_parameters").show();
				product.getPrice();
			} else {
				product.roundTrip = false;
				$("._transfer_return_parameters").hide();
				product.getPrice();
			}
			product.checkBtnBooking();
		});

		$(document).on("click", "button._extra", function () {
			const extraId = $(this).data("extra-id");
			const container = $(`input[name='extra[${extraId}]']`);
			const btnPlus = $(`button._plus._extra[data-extra-id=${extraId}]`);
			transfers.add_extra(extraId, container, btnPlus);
		});

		$(document).on("click", ".__add_extra", function () {
			const extraId = $(this).data("extra-id");
			transfers.add_extra(extraId, $(this));
		});
	},

	check_choice() {
		if ($("input[name=transfer_choice]:checked").val() === "RT") {
			$("._transfer_return_parameters").show();
			product.roundTrip = $("input[name=product_roundtrip]").val();
		}
	},

	add_extra(extraId, element, btn) {
		const priceGlobalProduct = (product.type_price === "TOTAL") ? $("input[name=fixed_price]").val() : 0;
		let totalParticipants = 0;

		$("input[data-op]").not(".__extra_opt").each(function () {
			totalParticipants += parseInt($(this).val(), 10);
		});

		const removeExtra = element.hasClass("_selected") ? "true" : "false";
		const arr = {
			id: extraId,
			price: element.data("price"),
			type_extra: element.data("type"),
			label: element.data("label"),
			value: null
		};

		if (arr.type_extra === "ANY") {
			arr.value = parseInt($(`input[name='extra[${arr.id}]']`).val(), 10);
			if (arr.value === 0) removeExtra = "true";

			if (parseInt(product.maxQuantity) === arr.value) {
				btn.addClass("_disabled").attr("disabled", "disabled");
			} else {
				btn.removeClass("_disabled").removeAttr("disabled");
			}
		}

		$.ajax({
			url: `${_SITE_URL}add-extra`,
			type: 'post',
			data: {
				extras: [arr],
				product_id: product.id,
				product_roundTrip: product.roundTrip,
				product_type: product.type_price,
				product_price: priceGlobalProduct,
				nb_pers: totalParticipants,
				remove: removeExtra
			},
			success(response) {
				const obj = $.parseJSON(response);
				const total = `<span>€ ${obj.total_price}</span><small class="_single">Total price - Taxes inc.</small>`;

				$(".--price_total").html(total).show();
				$(".__price_mobile").hide();
				$(".__price_total_mobile > ._contain").html(total);

				if (obj.nb > 0) {
					$(".--transfer-extras").show().html(obj.extras);
				} else {
					$(".--transfer-extras").hide();
				}

				if (arr.type_extra === "ANY") {
					$(`.--extras-list > li[data-extra-id=${arr.id}]`).toggleClass("__selected", arr.value !== 0);
				} else {
					const sentence = removeExtra === "true" ? "Add a stop or Extra" : "Remove stop";
					element.toggleClass("_selected", removeExtra !== "true");
					$(`.--extras-list > li[data-extra-id=${arr.id}]`).toggleClass("__selected", removeExtra !== "true");
					element.find("span").html(sentence);
				}
			}
		});
	},

	prepare_extras() {
		$.ajax({
			url: `${_SITE_URL}get-extras`,
			type: 'post',
			data: {product_id: product.id},
			success(response) {
				const obj = $.parseJSON(response);
				if (obj.nb > 0) {
					$(".--transfer-extras").show().html(obj.extras);
				} else {
					$(".--transfer-extras").hide();
				}
			}
		});
	}
};

export default transfers;
